import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Box, CircularProgress } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

// Interface definition for props
/**
 * @typedef {Object} ReportPreviewButtonProps
 * @property {string} pdfUrl - URL of the PDF to display
 * @property {boolean} [initialOpen] - Whether to open the modal immediately
 */

/**
 * @param {ReportPreviewButtonProps} props
 */

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background: black;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  height: 90%;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;
// const pdfoverlay = styled.div`
//   background-color: black !important;
// `;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background-color: black !important;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 36px;
  cursor: pointer;
  color: white;
`;

const Content = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PreviewButton = styled.button`
  background: none;
  border: 1px solid white;
  border-radius: 16px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  padding: 8px 16px;
  margin: 0 8px;
  outline: none;

  &:disabled {
    color: #a9a9a9;
    cursor: not-allowed;
  }
`;

const PDFIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background-color: black !important;
`;

const LoadingMessage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #666;
`;

const ReportPreviewButton = ({ pdfUrl, initialOpen = false, onClose }) => {
  const [isOpen, setIsOpen] = useState(initialOpen);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (initialOpen) {
      setIsOpen(true);
    }
  }, [initialOpen]);

  useEffect(() => {
    console.log('PDF URL in ReportPreviewButton:', pdfUrl);
  }, [pdfUrl]);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  return (
    <>
      <PreviewButton onClick={handleOpen} className="report-preview-button">
        Preview
      </PreviewButton>

      {isOpen && (
        <ModalOverlay onClick={handleClose}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h2>Report Preview</h2>
              <CloseButton onClick={handleClose}>×</CloseButton>
            </ModalHeader>
            <Content>
              {error ? (
                <div>Error loading PDF: {error}</div>
              ) : (
                <>
                  {loading && <LoadingMessage>Loading PDF...</LoadingMessage>}
                  <PDFIframe
                    src={`${pdfUrl}#toolbar=0&navpanes=0`}
                    title="Report Preview"
                    onLoad={() => {
                      console.log('PDF loaded successfully');
                      setLoading(false);
                    }}
                    onError={(e) => {
                      console.error('Error loading PDF:', e);
                      setError('Failed to load PDF. Please check the console for details.');
                      setLoading(false);
                    }}
                  />
                </>
              )}
            </Content>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default ReportPreviewButton; 